import { SHIPPING_CONDITION_CODE } from '../../../../shared/constants/shipping-conditions-codes';
import { delivery } from './delivery';

export const cementBag = {
  [SHIPPING_CONDITION_CODE.DELIVERY]: delivery,
};
